import { c as _c } from "react/compiler-runtime";
import { Divider } from "@flat-ui";
import { IntegrationDialog } from "@components/integrations-dialog/integration-dialog";
import { useTokensService } from "@context-providers/tokens-service-provider";
import { Stack } from "@mui-wrapper";
import { IntegrationRow } from "@pages/account-settings/integrations-account/integration-row";
import { IntegrationSettingsSkeleton } from "@pages/account-settings/integrations-account/integration-settings-skeleton";
import { useUserIntegrations } from "@pages/account-settings/integrations-account/use-user-integrations";
import { useState } from "react";

/**
 * Displays a list of available user-level integrations.
 * It handles enabling and disabling integrations and manages dialog states related to integration actions.
 */
export function IntegrationList() {
  const $ = _c(25);
  const tokensService = useTokensService();
  const [integrationId, setIntegrationId] = useState("autodesk");
  let t0;
  if ($[0] !== integrationId || $[1] !== tokensService) {
    t0 = {
      integrationId,
      tokensService
    };
    $[0] = integrationId;
    $[1] = tokensService;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const {
    allIntegrations,
    onEnableIntegration,
    dialogState,
    setDialogState,
    onSuccessDialogConfirm,
    onInProgressDialogCancel,
    onDisconnectDialogConfirm,
    onDisconnectDialogCancel,
    isLoadingIntegrations
  } = useUserIntegrations(t0);
  if (isLoadingIntegrations) {
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <IntegrationSettingsSkeleton />;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      width: "100%"
    };
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== allIntegrations.availableIntegrationIds || $[6] !== allIntegrations.enabledIntegrationIds || $[7] !== onEnableIntegration || $[8] !== setDialogState) {
    let t3;
    if ($[10] !== allIntegrations.availableIntegrationIds.length || $[11] !== allIntegrations.enabledIntegrationIds || $[12] !== onEnableIntegration || $[13] !== setDialogState) {
      t3 = (integrationId_0, index) => <Stack key={integrationId_0}><IntegrationRow integrationId={integrationId_0} enabledIntegrationIds={allIntegrations.enabledIntegrationIds} onEnable={integrationId_1 => {
          setIntegrationId(integrationId_1);
          onEnableIntegration(integrationId_1);
        }} onDisable={integrationId_2 => {
          setIntegrationId(integrationId_2);
          setDialogState("disconnect");
        }} />{index !== allIntegrations.availableIntegrationIds.length - 1 && <Divider />}</Stack>;
      $[10] = allIntegrations.availableIntegrationIds.length;
      $[11] = allIntegrations.enabledIntegrationIds;
      $[12] = onEnableIntegration;
      $[13] = setDialogState;
      $[14] = t3;
    } else {
      t3 = $[14];
    }
    t2 = allIntegrations.availableIntegrationIds.map(t3);
    $[5] = allIntegrations.availableIntegrationIds;
    $[6] = allIntegrations.enabledIntegrationIds;
    $[7] = onEnableIntegration;
    $[8] = setDialogState;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[15] !== dialogState || $[16] !== integrationId || $[17] !== onDisconnectDialogCancel || $[18] !== onDisconnectDialogConfirm || $[19] !== onInProgressDialogCancel || $[20] !== onSuccessDialogConfirm) {
    t3 = <IntegrationDialog integrationId={integrationId} dialogState={dialogState} onSuccessDialogConfirm={onSuccessDialogConfirm} onInProgressDialogCancel={onInProgressDialogCancel} onDisconnectDialogConfirm={onDisconnectDialogConfirm} onDisconnectDialogCancel={onDisconnectDialogCancel} />;
    $[15] = dialogState;
    $[16] = integrationId;
    $[17] = onDisconnectDialogCancel;
    $[18] = onDisconnectDialogConfirm;
    $[19] = onInProgressDialogCancel;
    $[20] = onSuccessDialogConfirm;
    $[21] = t3;
  } else {
    t3 = $[21];
  }
  let t4;
  if ($[22] !== t2 || $[23] !== t3) {
    t4 = <Stack sx={t1}>{t2}{t3}</Stack>;
    $[22] = t2;
    $[23] = t3;
    $[24] = t4;
  } else {
    t4 = $[24];
  }
  return t4;
}